import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentFlightHotel } from '../../../model/content/contentFlightHotel.model';
import { ContentHeaderFooterService } from '../../../services/content/contentheaderfooter.service';

@Component({
  selector: 'ngc-flight-plus-hotel',
  templateUrl: './flight-plus-hotel.component.html'
})
export class FlightPlusHotelComponent implements OnInit, OnDestroy {
  config = {
    animated: false
  };

  flightHotelContent: ContentFlightHotel;
  contentServiceHeaderFooterSubscribe: Subscription;
  @Output() action = new EventEmitter();
  @Input() passengers = '';
  @Input() destination = '';
  @Input() travelDates = '';
  @Input() destinationCity = '';
  @Input() modalType = '';
  externalLinkButtonLabel: string;
  flightOnlyButtonLabel: string;
  @ViewChild('dialog') dialog: any;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public bsModalRef: BsModalRef,
    private contentService: ContentHeaderFooterService,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                if (this.modalType === 'JV') {
                  this.flightHotelContent = data.nonJVFlying;
                  this.externalLinkButtonLabel = 'dohop';
                  this.flightOnlyButtonLabel = 'cancel';
                } else {
                  this.flightHotelContent = data.flightPlusHotel;
                  this.externalLinkButtonLabel = 'fph';
                  this.flightOnlyButtonLabel = 'search';
                  this.destinationCity = '';
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  ngOnDestroy() {
    // Loadtest ObsUnsub added
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }

  setValue(val) {
    this.close();
    this.action.emit(val);
  }

  close() {
    this.bsModalRef.hide();
  }
}
